
  import { Swiper, SwiperSlide } from 'swiper-vue2'
  import SwiperCore, { Autoplay } from 'swiper'
  import 'swiper/swiper-bundle.css'

  SwiperCore.use([Autoplay])

  export default {
    name: 'ThemeStoresMobileIosComments',
    components: { Swiper, SwiperSlide },
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      },
      comments() {
        return [
          {
            id: 1,
            name: this.tl('firstCommentUser'),
            averageRating: 5,
            date: this.tl('firstCommentDate'),
            textContent: this.tl('firstCommentContent')
          },
          {
            id: 2,
            name: this.tl('secondCommentUser'),
            averageRating:
              ~~this.pwa?.pwa_app_settings?.overall_ratings === 5
                ? 5
                : ~~this.pwa?.pwa_app_settings?.overall_ratings,
            date: this.tl('secondCommentDate'),
            textContent: this.tl('secondCommentContent')
          }
        ]
      }
    },
    methods: {
      getPartialFillWidth() {
        return 0
      }
    }
  }
